// LUM MODULES

// ANGULAR MODULES
import { CommonModule } from '@angular/common';
import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { RouterModule } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';

import { FeatureModule } from 'v2/shared/feature/feature.module';

import { MaterialCustomModule } from '../../material-custom.module';
import { SharedComponentsModule } from '../../shared-components.module';
import { AppIntegrationAccountProductMappingCheckboxCellRendererComponent } from '../app-integration-account/components/app-integration-account-product-mapping-checkbox-cell-renderer/app-integration-account-product-mapping-checkbox-cell-renderer.component';
import { FilterModule } from '../filter/filter.module';

// COMPONENTS
import { DirectiveModule } from '../shared/directives/directive.module';
import { PipeModule } from '../shared/pipes/pipe.module';
import { SharedModule } from '../shared/shared.module';
import { UiModule } from '../ui/ui.module';

import {
  ChannelFormComponent,
  ChannelFormWoocommerceCredsComponent,
  ChannelFormAmazonCredsComponent,
  ChannelFormApi2cartCredsComponent,
  ChannelFormHubspotCredsComponent,
  ChannelFormFeesComponent,
  ChannelFormShopifyCredsComponent,
  ChannelProductMappingComponent,
  ChannelProductMappingActionCellRendererComponent,
  ChannelProductSyncProductsFormComponent,
  ChannelProductMappingSearchSkuCellEditorComponent,
  ChannelProductMappingCheckboxCellRendererComponent,
  ChannelFormFiltersComponent,
  ChannelFormV2Component,
  ChannelCreateComponent,
  ChannelProductMappingV2Component,
  ChannelProductMappingSearchUomEditorComponent,
  ChannelComponent,
  ChannelTableComponent,
  ChannelFiltersComponent,
  ChannelFormPushCustomFieldsComponent,
  ChannelCustomFieldsComponent,
  ChannelProductMappingSkuCellRendererComponent,
  ChannelDetailsComponent,
  ChannelProductMappingCheckboxCellRendererV2Component,
  ChannelProductMappingActionCellRendererV2Component,
  ChannelProductMappingUnifiedComponent,
  ChannelProductMappingSearchInvLocationComponent,
  ChannelProductMappingLastPushedCellRendererComponent,
} from './components';
import { ChannelOutgoingCustomFieldsPipe } from './pipes/channel-outgoing-custom-fields.pipe';

const components = [
  ChannelFormComponent,
  ChannelFormWoocommerceCredsComponent,
  ChannelFormAmazonCredsComponent,
  ChannelFormApi2cartCredsComponent,
  ChannelFormHubspotCredsComponent,
  ChannelFormFeesComponent,
  ChannelFormShopifyCredsComponent,
  ChannelProductMappingComponent,
  ChannelProductMappingActionCellRendererComponent,
  ChannelProductSyncProductsFormComponent,
  ChannelProductMappingSearchSkuCellEditorComponent,
  ChannelProductMappingCheckboxCellRendererComponent,
  ChannelFormFiltersComponent,
  ChannelFormV2Component,
  ChannelCreateComponent,
  ChannelProductMappingV2Component,
  ChannelProductMappingSearchUomEditorComponent,
  ChannelComponent,
  ChannelTableComponent,
  ChannelFiltersComponent,
  ChannelFormPushCustomFieldsComponent,
  ChannelCustomFieldsComponent,
  ChannelProductMappingSkuCellRendererComponent,
  ChannelDetailsComponent,
  ChannelProductMappingCheckboxCellRendererV2Component,
  ChannelProductMappingActionCellRendererV2Component,
  ChannelProductMappingUnifiedComponent,
  ChannelProductMappingSearchInvLocationComponent,
  ChannelProductMappingLastPushedCellRendererComponent,
];

const standaloneComponents = [
  AppIntegrationAccountProductMappingCheckboxCellRendererComponent,
];

const angularModules = [
  CommonModule,
  ReactiveFormsModule,
  MatSlideToggleModule,
  MatFormFieldModule,
  MatSelectModule,
  MaterialCustomModule,
  AgGridModule,
  RouterModule,
  FormsModule,
];

const lumModules = [
  SharedComponentsModule,
  SharedModule,
  UiModule,
  DirectiveModule,
  PipeModule,
  FilterModule,
];

const pipes = [FeatureModule, ChannelOutgoingCustomFieldsPipe];

@NgModule({
  declarations: [...components],
  imports: [...angularModules, ...lumModules, ...pipes, ...standaloneComponents],
  exports: [...components],
  schemas: [NO_ERRORS_SCHEMA],
})
export class ChannelModule {}
